import { render, staticRenderFns } from "./VideoDialog2.vue?vue&type=template&id=ed7f795c&scoped=true"
import script from "./VideoDialog2.vue?vue&type=script&lang=js"
export * from "./VideoDialog2.vue?vue&type=script&lang=js"
import style0 from "./VideoDialog2.vue?vue&type=style&index=0&id=ed7f795c&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7f795c",
  null
  
)

export default component.exports